export default "__VITE_ASSET__GUQonmDl__"